// extracted by mini-css-extract-plugin
export var addButton = "_ou-0";
export var border = "_ou-8";
export var check = "_ou-h";
export var danger = "_ou-6";
export var dropdownContainer = "_ou-1";
export var editModalBody = "_ou-j";
export var footerContainer = "_ou-i";
export var fullWidth = "_ou-a";
export var hide = "_ou-9";
export var icon = "_ou-3";
export var input = "_ou-7";
export var inputFlex = "_ou-b";
export var inputWrapper = "_ou-c";
export var manualFocus = "_ou-5";
export var optionButton = "_ou-4";
export var pillWrapper = "_ou-e";
export var pointer = "_ou-2";
export var showOverflow = "_ou-f";
export var tagsFlex = "_ou-d";
export var xButton = "_ou-g";